import { Typography, Button, Select, MenuItem, FormControl, InputLabel, Switch, FormControlLabel, Box } from "@mui/material";
import { DateField, DatePicker, DateTimeField, DateTimePicker } from "@mui/x-date-pickers";
import { useCallback, useEffect, useState } from "react";
import { UB_DASHBOARD_FILTER_TYPE } from "../../utils/constants";
import { UBItem } from "./UBItem"
import moment from "moment";

export const UBDashboardFilter = ({value, onChange, title, subtitle}) => {
    const [filterType, setFilterType] = useState(value.filterType);
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [start, setStart] = useState(value.start);
    const [end, setEnd] = useState(value.end);

    console.log(start);

    const onFilterTypeChange = (e) => {
        setFilterType(e?.target?.value);

        if (e?.target?.value === UB_DASHBOARD_FILTER_TYPE.DATE_TIME_RANGE) {
        }

        if (e?.target?.value === UB_DASHBOARD_FILTER_TYPE.DATE_RANGE) {
            setStart(start.startOf("day"));
            setEnd(end.endOf("day"));
        }
    }

    const onApply = useCallback((e) => {
        onChange({ start: start.clone(), end: end.clone(), filterType: filterType });
    }, [end, filterType, onChange, start]);

    const handleAutoRefresh = (e) => {
        setAutoRefresh(e.target.checked);
    };

    useEffect(() => {
        if (autoRefresh) {
            const interval = setInterval(() => {
                if (filterType === UB_DASHBOARD_FILTER_TYPE.DATE_TIME_RANGE) {
                    const currentDate = moment(new Date());
                    const remainder = 5 - (currentDate.minute() % 5);
                    const dateTime = currentDate
                        .add(remainder, "minutes")
                        .set("second", 0);
                    setEnd(dateTime);
                }

                onApply();
            }, 5*60*1000);

            return () => clearInterval(interval);
        }
    }, [autoRefresh, onApply]);

    return (
        <UBItem styles={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
            <Box
                sx={{ mr: "auto", ml: 2 }}
            >
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    align="left"
                    alignSelf="center"
                    component="div"
                >
                    {title}
                </Typography>

                <Typography
                    variant="body1"
                    align="left"
                    alignSelf="center"
                    component="div"
                >
                    {subtitle}
                </Typography>
            </Box>

            <FormControl variant="outlined" sx={{ ml: "auto", minWidth: 80 }}>
                <InputLabel id="select-filter-type">Filter Type</InputLabel>

                <Select
                    variant="outlined"
                    labelId="select-filter-type"
                    value={filterType}
                    label="Filter Type"
                    autoWidth
                    onChange={onFilterTypeChange}>
                    <MenuItem value={UB_DASHBOARD_FILTER_TYPE.DATE_RANGE}>Date Range</MenuItem>
                    <MenuItem value={UB_DASHBOARD_FILTER_TYPE.DATE_TIME_RANGE}>Date Time Range</MenuItem>
                </Select>
            </FormControl>

            {filterType === UB_DASHBOARD_FILTER_TYPE.DATE_TIME_RANGE &&
                <DateTimePicker
                    label="Start"
                    value={start}
                    onChange={newValue => setStart(newValue)}
                    sx={{ px: 1 }}
                    // renderInput={(params) => <TextField {...params}/>}
                />
            }

            {filterType === UB_DASHBOARD_FILTER_TYPE.DATE_RANGE &&
                <DatePicker
                    label="Start"
                    value={start}
                    onChange={newValue => setStart(newValue)}
                    sx={{px: 1}}
                />
            }

            {filterType === UB_DASHBOARD_FILTER_TYPE.DATE_TIME_RANGE &&
                <DateTimePicker
                    label="End"
                    value={end}
                    onChange={newValue => setEnd(newValue)}
                    sx={{pr: 1}}
                />
            }

            {filterType === UB_DASHBOARD_FILTER_TYPE.DATE_RANGE &&
                <DatePicker
                    label="End"
                    value={end}
                    onChange={newValue => setEnd(newValue)}
                    sx={{pr: 1}}
                />
            }

            <Button
                onClick={onApply}
                sx={{ color: 'white', borderColor: 'white', display: 'block', textTransform: 'none' }}
            >
                <Typography variant="h6" fontWeight="bold" align="left">Refresh</Typography>
            </Button>

            <FormControl variant="outlined" sx={{ }}>
                <FormControlLabel
                    value="top"
                    control={
                        <Switch
                            checked={autoRefresh}
                            onChange={handleAutoRefresh}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                    label="Auto Refresh"
                    labelPlacement="top"
                />
            </FormControl>
        </UBItem>
    );
}